const styles = (theme) => ({
  trailerGridHeight: {
    "&$dataGrid": {
      height: "55%",
    },
  },
  shipmentGridHeight: {
    "&$dataGrid": {
      height: "31%",
    },
  },
  dataGrid: {
    boxSizing: "border-box",
    border: `1px solid ${theme.AppBGColor}`,
    height: "calc(100% - 40px)",
    [`&>.gridTheme-${theme.themeName}`]: {
      height: "100%",
    },    
  },
  trailerContainer: {
    padding: "0px 18px 12px 18px",
  },
  shipmentContainer: {
    padding: "0px 18px 0px 18px",
  },
});

export default styles;
